/** The one image on the home page: the home screen, drawn in HTML so it is always the real design. Example data. */
export function HomeShot({ compact = false }: { compact?: boolean }) {
  const row = (t: string, n: string, from: string, done = false) => (
    <div key={n} className="grid grid-cols-[48px_1fr_18px] items-center gap-2 py-2 border-b border-line last:border-0">
      <span className="text-xs font-semibold text-muted tnum">{t}</span>
      <span className="text-[13px] leading-tight">{n}<span className="block text-[11px] text-muted">{from}</span></span>
      <span className={`h-[18px] w-[18px] rounded-md border-[1.5px] border-indigo ${done ? "bg-indigo" : ""}`} />
    </div>
  );
  return (
    <div className="w-full max-w-[380px] rounded-[32px] border-2 border-ink/90 bg-white p-4 shadow-[0_24px_60px_rgba(17,24,39,.14)] text-left">
      <div className="mx-auto mb-4 h-1.5 w-20 rounded-full bg-line" />
      <div className="space-y-4 text-sm">
        <div>
          <div className="text-xl font-bold">Good morning, Srini</div>
          <div className="text-xs text-muted">Thursday, 2 October · 3 tasks · 2 reminders · 1 bill this week</div>
        </div>
        <div className="flex items-center justify-between rounded-xl border border-line bg-panel px-3 py-2.5 text-muted">
          <span>Ask Lifeable anything…</span><span className="text-indigo font-bold">→</span>
        </div>
        <div>
          <div className="text-[11px] font-semibold uppercase tracking-wider text-muted mb-1.5">Today</div>
          <div className="rounded-xl bg-panel px-3 py-1">
            {row("8:00", "Amma's BP tablet", "Health", true)}
            {row("9:30", "Pay electricity bill · ₹2,140", "Bill")}
            {row("11:00", "Dentist, Dr Rao", "Appointment")}
            {row("Today", "Book Aarav's bus pass", "Task")}
            {row("7:00 pm", "Evening walk · day 12", "Habit")}
          </div>
        </div>
        <div>
          <div className="text-[11px] font-semibold uppercase tracking-wider text-muted mb-1.5">Coming up</div>
          <div className="flex gap-2 overflow-hidden">
            {[["Sat 4 Oct", "Car insurance", "₹8,400"], ["Mon 6 Oct", "Amma's birthday", "Gift: shawl"], ["Sun 12 Oct", "Goa trip", "4 days"]].map(([d, n, s]) => (
              <div key={n} className="min-w-[104px] rounded-xl bg-panel px-3 py-2">
                <div className="text-[11px] font-semibold text-indigo">{d}</div>
                <div className="text-[13px] font-semibold leading-tight">{n}</div>
                <div className="text-xs text-muted">{s}</div>
              </div>
            ))}
          </div>
        </div>
        {compact ? null : <div>
          <div className="text-[11px] font-semibold uppercase tracking-wider text-muted mb-1.5">Money</div>
          <div className="rounded-xl bg-panel px-3 py-3">
            <div className="text-xs text-muted">October spending</div>
            <div className="text-lg font-bold tnum">₹32,450 <span className="text-xs font-medium text-muted">/ ₹50,000 budget</span></div>
            <div className="my-2 h-1.5 rounded bg-line overflow-hidden"><div className="h-full w-[65%] bg-indigo" /></div>
            <div className="flex justify-between text-xs text-muted tnum"><span>Food ₹7,200</span><span>Bills ₹11,300</span><span>Shopping ₹4,500</span></div>
          </div>
        </div>}
        <div className="grid grid-cols-5 border-t border-line pt-3 text-center text-[11px] text-muted">
          <span className="text-indigo font-semibold">Today</span><span>Life</span>
          <span><span className="inline-grid h-7 w-7 place-items-center rounded-full bg-indigo text-white font-bold text-base leading-none">+</span></span>
          <span>Ask</span><span>Me</span>
        </div>
      </div>
    </div>
  );
}
